import React from 'react';

import { IQuoteDropdown } from './interface';

import { Column } from '../Layout/Grid';
import Text from '../Text';
import Table from 'components/Table';

/**
 * @main QuoteDropdown is the main exported component
 * @param items it is a quote item list
 */
const QuoteDropdown: React.FC<IQuoteDropdown> = ({
  items,
  subsidiaryElement,
}) => {
  const setSubsidiary = () => {
    if (subsidiaryElement?.subsidiaryCode) {
      return `( filial : ${subsidiaryElement?.subsidiaryCode} - ${subsidiaryElement?.subsidiaryName} )`;
    }

    return "";
  };

  return (
    <Column className="animated fadeIn my-2 px-md-2">
      <Text className="font-bold color-blue-gray mt-2 mb-3" size={12}>
        {`Itens de cotações ${setSubsidiary()}`}
      </Text>
      <Table
        trackingKey="Items da Cotaçao"
        onReload={() => { }}
        setTableOrder={() => { }}
        tableOrder=""
        data={items || undefined}
        pageSize={items?.length || 1}
        currentPage={0}
        totalPages={1}
        model={[
          // { label: "Item", noFilter: true, size: 80, maxSize: 80 },
          { label: 'Código', key: 'code', size: 80, maxSize: 80 },
          { label: 'Produto', key: 'name', size: 240 },
          { label: 'Unidade', key: 'unit', size: 100, maxSize: 100 },
          { label: 'Qtd.', key: 'quantity', size: 70, maxSize: 70 },
          {
            label: 'Valor',
            key: 'price',
            type: 'currency',
            size: 115,
            maxSize: 115,
          },
          // { label: "Lote", key: "code", size: 70, maxSize: 70 },
        ]}
      />
    </Column>
  );
};

export default QuoteDropdown;
